/**
 * 订单操作记录页面路径
 */
export const ORDER_RECORD_PAGE_PATH = '/order/record'
